import { isImpersonatingSession } from './impersonationSession';

/**
 * Gate funcional da entrada Cakto Partners. `is_partner` é a única fonte da
 * elegibilidade: o backend liga o campo quando o admin ativa o parceiro. A Função
 * Experimental `partnership` foi o rollout do piloto e não decide mais o acesso.
 * Sessão impersonada não tem acesso — todo endpoint de parceiro dá 403 nesse modo.
 */
export const hasPartnersAccess = (user) => user?.is_partner === true && !isImpersonatingSession();
